import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: " श्री. दिलीप पांडुरंग पाटील ", designation: "ग्रामपंचायत घोणसई - मेट ",  imageUrl: "/images/dilip.jpeg" },
  { name: "श्री. अशोक नामदेव घोरकणे", designation: "ग्रामपंचायत घोणसई - मेट",  imageUrl: "/images/ashok.jpeg" },
  { name: "सौ.विजयता विलास भोईर", designation: "ग्रामपंचायत घोणसई - मेट",  imageUrl: "/images/vijayata.jpeg" },
  { name: "सौ. प्रमिला प्रविण वझरे", designation: "ग्रामपंचायत घोणसई - मेट", imageUrl: "/images/pramila.jpeg" },
  { name: "सौ. कविता वैभव पाटील", designation: "ग्रामपंचायत घोणसई - मेट",  imageUrl: "/images/kavita.jpeg" },
  { name: "सौ. गीता सुरेश वाघ", designation: "ग्रामपंचायत घोणसई - मेट",  imageUrl: "/images/gita.jpeg" },
   { name: "सौ. मंजु राजु राठोड", designation: "ग्रामपंचायत घोणसई - मेट",  imageUrl: "/images/manju.jpeg" },
    { name: "सौ. ममता दिनेश घोडविंदे", designation: "ग्रामपंचायत घोणसई - मेट",  imageUrl: "/images/mamata.jpeg" },
  
  ];

const karmachariMembers = [
 /* { name: "--", designation: " ग्रामपंचायत कर्मचारी ",  imageUrl: "/images/-.jpeg" },
  { name: "--", designation: "रोजगार सेवक घोणसई - मेट",   imageUrl: "/images/-.jpeg" },
  { name: "-- ", designation: "संगणक प्ररिचालक घोणसई - मेट",   imageUrl: "/images/-.jpeg" },
  { name: " श्री. ", designation: "सफाई  कर्मचारी", imageUrl: "/images/sharad.jpeg" },
  { name: "श्री.  ", designation: "लिपिक  कर्मचारी", imageUrl: "/images/puru.jpeg" },
  { name: "श्री.", designation: "ग्रामपंचायत कर्मचारी", imageUrl: "/images/nikhil.jpeg" },
  { name: "श्री.", designation: "संगणक परिचालक", imageUrl: "/images/pritam.jpeg" },
  { name: "श्री.", designation: "पानी पुरवठा  कर्मचारी", imageUrl: "/images/ajay.jpeg" },*/
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone"> {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">--</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2026 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
